exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cap-it-ui-alert-bar .info-alert-bar .alert-bar-base{background-color:rgba(80,148,190,.9)}.cap-it-ui-alert-bar .info-alert-bar h3{font-weight:400;margin-bottom:0;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/alert-bar/styles/info-alert-bar.scss
// module id = 5232
// module chunks = 0